export default __webpack_public_path__ + "static/media/alarm.21e3b383.svg";